import React from 'react';
import useTitle from '../../../hooks/useTitle';

const ResetPassword = () => {
    useTitle("Reset Password")
    return (
        <div>
            
        </div>
    );
};

export default ResetPassword;